/**
 * Telling a page's 403 apart from "you need two-factor first".
 *
 * `MfaRequiredGuard` on the backend refuses every `compliance.*`,
 * `approvals.*` and `payroll.manage` action — reads included — from an admin
 * who has not enrolled an authenticator. That is a 403 like any permission
 * failure, and each page used to report it as its own load error, which
 * reads as broken rather than as a step the admin can take.
 *
 * The API client announces it instead, and one notice in the layout points at
 * the enrolment page. The pages need no change to benefit.
 */
export const MFA_REQUIRED_EVENT = 'payiq:mfa-required';

interface ErrorLike {
  response?: { status?: number; data?: { message?: unknown } };
}

export function isMfaRequired(error: unknown): boolean {
  const response = (error as ErrorLike | null)?.response;
  if (response?.status !== 403) return false;
  const message = response.data?.message;
  return typeof message === 'string' && /multi-factor/i.test(message);
}

export function announceMfaRequired(): void {
  window.dispatchEvent(new Event(MFA_REQUIRED_EVENT));
}
